Jr = (function (me) {
    me.Utils = {};
    const utils = me.Utils;

    utils.checkKey = function (event, testForKey) {
        const key = event.key || event.keyCode;

        switch (testForKey) {
            case 'escape':
                return key === 'Escape' || key === 'Esc' || key === 27;
            case 'return':
            case 'enter':
                return key === 'Enter' || key === 13 || 'NumpadEnter';
            default:
                return false;
        }
    };

    utils.convertRowDate = function (row, format, timeagoArray) {
        // we're getting a UTC date from the DB... need to convert it to the users timezone...?
        Object.keys(row).forEach((key) => {
            if (key.indexOf('date_') >= 0 || key.indexOf('_date') >= 0 || key.indexOf('archived_at') >= 0) {
                const momentDate = moment.utc(row[key]).tz(moment.tz.guess());

                if (row[key] != null) {
                    if ($.inArray(key, timeagoArray) !== -1) {
                        // eslint-disable-next-line no-param-reassign
                        row[key] = momentDate.fromNow();
                    } else {
                        // eslint-disable-next-line no-param-reassign
                        row[key] = momentDate.format(format);
                    }
                }
            }
        });

        return row;
    };

    utils.convertDate = function (rawDate, format, timeAgo = false) {
        if (!rawDate) {
            return rawDate;
        }

        let momentDate = moment.utc(rawDate);
        let formattedDate;
        // if date length > 10 it includes time.
        if (rawDate.length > 10) {
            momentDate = moment.utc(rawDate).tz(moment.tz.guess());
            if (timeAgo) {
                formattedDate = `<time title="${momentDate.format('MMMM Do YYYY, h:mm:ss a')}">${momentDate.fromNow()}</time>`;
            } else {
                formattedDate = `<time title="${momentDate.format('MMMM Do YYYY, h:mm:ss a')}">${momentDate.format(format)}</time>`;
            }
        } else {
            // if date length <= 10, it's just a date, no time (like MM/DD/YYYY), so don't adjust for timezone!
            momentDate = moment.utc(rawDate);
            if (timeAgo) {
                formattedDate = `<time title="${momentDate.format('MMMM Do YYYY')}">${momentDate.fromNow()}</time>`;
            } else {
                formattedDate = `<time title="${momentDate.format('MMMM Do YYYY')}">${momentDate.format('MM/DD/YYYY')}</time>`;
            }
        }

        return formattedDate;
    };

    /*
     * Custom sorter for bootstrap table columns with dates
     */
    utils.dateSorter = function (a, b) {
        if (a === null) {
            return -1;
        }

        if (b === null) {
            return -1;
        }

        if (!a.date || !b.date) {
            return -1;
        }

        if (a.date < b.date) {
            return -1;
        }

        if (a.date > b.date) {
            return 1;
        }

        return 0;
    };

    utils.validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    return me;
}(Jr || {}));
